import { ProductTransition } from "@/api/models/product-transition/productTransition.model";
import { productMultipleTransitionProcessInitialState } from "./productMultipleTransitionProcess";
import { PRODUCT_MULTIPLE_TRANSITION_PROCESS_CLEAR_STATE } from "./constants";

const clear = (state: any) => {
	Object.assign(state, productMultipleTransitionProcessInitialState());
};

const setProductMultipleTransition = (state: any, productTransition: ProductTransition) => {
	state.productTransition = productTransition;
};

const setProductMultipleTransitionShoppingCartId = (state: any, shoppingCartId: string) => {
	state.shoppingCartId = shoppingCartId;
};

const setProductMultipleTransitionStatus = (state: any, status: string) => {
	state.status = status;
};

export default {
	[PRODUCT_MULTIPLE_TRANSITION_PROCESS_CLEAR_STATE]: clear,
	setProductMultipleTransition,
	setProductMultipleTransitionShoppingCartId,
	setProductMultipleTransitionStatus
};
